"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/ro");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  announcements_a4b8ed4a: {
    message: "Anun\u021Buri"
  },
  assignments_1e02582c: {
    message: "Teme"
  },
  discussions_a5f96392: {
    message: "Discu\u021Bii"
  },
  files_c300e900: {
    message: "Fi\u0219iere"
  },
  loading_25990131: {
    message: "Se \xEEncarc\u0103..."
  },
  pages_e5414c2c: {
    message: "Pagini"
  },
  people_b4ebb13c: {
    message: "Persoane"
  },
  quizzes_7e598f57: {
    message: "Test"
  },
  search_280d00bd: {
    message: "Caut\u0103"
  }
};

_formatMessage.default.addLocale({
  ro: locale
});